/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/


//table columns for area management table section 
export const columns: TableColumn[] = [
    {
        Header: "operatorManagement.tableColumns.slNo",
        accessor: "slno",
      },
      {
        Header: 'Production Schedule',
        accessor: 'production_schedule_name',
      },
      {
        Header: 'Product Name',
        accessor: 'product_name',
      },
      {
        Header: "tableCommon.batch_code",
        accessor: "batch_id",
      },
      {
        Header: "tableCommon.seriel_number",
        accessor: "serial_number",
      },
      {
        Header: "operatorManagement.tableColumns.activityType",
        accessor: "plate_type",
      },
      {
        Header: "operatorManagement.tableColumns.duration",
        accessor: "incubation_duration",
      },
      {
        Header: "operatorManagement.tableColumns.plateStatus",
        accessor: "status",
      },
  ];
  
  interface TableColumn {
    Header: string;
    accessor: string;
  }
  